import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate, IEventUpdate} from "../../services/models/event";
import {toast} from "react-toastify";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";
import {IFolder, IFolderCreate, IFolderUpdate} from "../../types/knowledgeBase.types";

export function useDeleteKBFolder() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [KNOWLEDGE_BASE_ENDPOINTS.DELETE_FOLDER],
        mutationFn: (id: string) => KnowledgeBaseAPI.deleteFolder(id),

        onError() {
            toast.error("Ошибка удаления папки");
        },

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDERS] });
            toast.success("Папка удалена");
        }
    });
}
